import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M494.279 479.591 358.022 243.167l-63.911-110.833L221.755 6.821c-5.247-9.092-18.368-9.095-23.619-.006l-.002.006-136.576 236.17-55.806 96.505c-5.258 9.095 1.303 20.47 11.808 20.475h.002l105.423.066c4.871 0 9.374-2.594 11.821-6.806l54.784-94.768 8.379-14.493q.495-.84 1.1-1.606c5.973-7.585 17.72-6.737 22.543 1.628l56.851 98.616 10.524 18.221a14.6 14.6 0 0 1 1.341 3.2c2.384 8.698-4.176 17.275-13.195 17.253l-124.018-.076a13.66 13.66 0 0 0-11.821 6.806l-52.783 91.271c-5.258 9.085 1.293 20.454 11.789 20.464h.01l109.293.077 136.279.088 136.554.088c10.477.007 17.048-11.316 11.843-20.409",
      class: "cls-1"
    }, null, -1)
  ])))
}
export default { render: render }